import { DriveStep } from "driver.js";

import { getCommonFinalSteps } from "./commonSteps";

export const getHomePageTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="weather-widget"]',
    popover: {
      title: t("tour.homepage.weather.title"),
      description: t("tour.homepage.weather.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="sam-chat"]',
    popover: {
      title: t("tour.homepage.samChat.title"),
      description: t("tour.homepage.samChat.description"),
      side: "left",
      align: "start",
    },
  },
  {
    element: '[data-tour="map-container"]',
    popover: {
      title: t("tour.homepage.map.title"),
      description: t("tour.homepage.map.description"),
      side: "right",
      align: "start",
    },
  },
  {
    element: '[data-tour="pinboard"]',
    popover: {
      title: t("tour.homepage.pinboard.title"),
      description: t("tour.homepage.pinboard.description"),
      side: "left",
      align: "start",
    },
  },
  {
    element: '[data-tour="explore-bx"]',
    popover: {
      title: t("tour.homepage.explore.title"),
      description: t("tour.homepage.explore.description"),
      side: "top",
      align: "center",
    },
  },
  ...getCommonFinalSteps(t),
];

export const homePageTourConfig = {
  id: "homepage" as const,
  steps: getHomePageTourSteps,
};
